import {
  Box,
  Breadcrumbs,
  Link,
  ListItem,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  Typography,
  Divider,
  IconButton,
  Drawer,
  Tooltip,
  Button,
  Menu,
} from "@mui/material";
import React, { useState } from "react";
import DateRangeIcon from "@mui/icons-material/DateRange";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import SettingsIcon from "@mui/icons-material/Settings";
import Configuration from "./SpaceModules/Configuration";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import ListIcon from "@mui/icons-material/List";
import CreateBooking from "./SpaceModules/CreateBooking";
import SpaceCalendar from "./SpaceCalendar";
import RoomPreferencesIcon from "@mui/icons-material/RoomPreferences";
import PackageConfiguration from "./SpaceModules/PackageConfiguration";
import Reports from "./reports/Reports";

function SingleRentalSpaceDashboard() {
  const url = new URL(window.location.href);
  const hotelId = url.searchParams.get("hotelId");
  const history = useHistory();
  const location = useLocation();
  const singleSpaceInfo = location.state;
  const [menuOption, setMenuOption] = useState("space");
  const [isMenuVisible, setIsMenuVisible] = useState(true);
  const [openConfiguration, setOpenConfiguration] = useState(false);
  const [gridRefresh, setGridRefresh] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const openAction = Boolean(anchorEl);

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ paddingTop: "6px" }}>
          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb"
          >
            <Link
              underline="hover"
              key="1"
              color="inherit"
              onClick={() => history.push(`/rental-space/?hotelId=${hotelId}`)}
            >
              Spaces
            </Link>
            ,
            <Typography key="3" sx={{ color: "text.primary" }}>
              {singleSpaceInfo?.name}
            </Typography>
            ,
          </Breadcrumbs>
        </Box>
        <Box>
          <IconButton
            aria-haspopup="true"
            aria-expanded={openAction ? "true" : undefined}
            onClick={(e) => setAnchorEl(e.currentTarget)}
          >
            <SettingsIcon />
          </IconButton>

          <Menu
            id="demo-positioned-menu"
            aria-labelledby="demo-positioned-button"
            anchorEl={anchorEl}
            open={openAction}
            onClose={() => setAnchorEl(null)}
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          >
            <MenuItem
              onClick={() => {
                setOpenConfiguration(true);
                setMenuOption("package");
                setAnchorEl(null);
              }}
            >
              Configure Packages
            </MenuItem>
            <MenuItem
              onClick={() => {
                setOpenConfiguration(true);
                setMenuOption("space");
                setAnchorEl(null);
              }}
            >
              Add {singleSpaceInfo?.name}
            </MenuItem>
            {/* <MenuItem
              onClick={() => {
                setOpenConfiguration(true);
                setMenuOption("reports");
                setAnchorEl(null);
              }}
            >
              Reports
            </MenuItem> */}
          </Menu>
        </Box>

        {/* <Box sx={{ display: "flex", gap: 1 }}>
          <Button
            variant="custom-button"
            onClick={() => {
              setOpenConfiguration(true);
              setMenuOption("package");
            }}
          >
           
            Configure packages
          </Button>
          <Button
            variant="custom-button"
            onClick={() => {
              setOpenConfiguration(true);
              setMenuOption("space");
            }}
          >
            Add {singleSpaceInfo?.name}
          </Button>
        </Box> */}
      </Box>

      <Divider sx={{ marginY: 1 }} />
      <SpaceCalendar
        singleSpaceInfo={singleSpaceInfo}
        hotelId={hotelId}
        gridRefresh={gridRefresh}
      />

      <Drawer
        anchor={"right"}
        open={openConfiguration}
        onClose={() => setOpenConfiguration(false)}
      >
        {menuOption === "space" && (
          <Configuration
            singleSpaceInfo={singleSpaceInfo}
            hotelId={hotelId}
            setOpenConfiguration={setOpenConfiguration}
            setGridRefresh={setGridRefresh}
          />
        )}
        {menuOption === "package" && (
          <PackageConfiguration
            singleSpaceInfo={singleSpaceInfo}
            hotelId={hotelId}
            setOpenConfiguration={setOpenConfiguration}
            setGridRefresh={setGridRefresh}
          />
        )}
        {menuOption === "reports" && (
          <Reports
            singleSpaceInfo={singleSpaceInfo}
            hotelId={hotelId}
            setOpenConfiguration={setOpenConfiguration}
            setGridRefresh={setGridRefresh}
          />
        )}
      </Drawer>
    </Box>
  );
}

export default SingleRentalSpaceDashboard;
